module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Anwil-a5a809198510e22f7dcc813c456f4ccb.svg";